export const ROCKET_COLORS = [
  { name: "Nova Pink", hex: "#FF3366" },
  { name: "Cyan Comet", hex: "#00F0FF" },
  { name: "Solar Yellow", hex: "#FFD166" },
  { name: "Emerald", hex: "#06D6A0" },
  { name: "Plasma Purple", hex: "#A855F7" },
  { name: "Blaze Orange", hex: "#FF6B35" },
  { name: "Cosmic Blue", hex: "#3B82F6" },
  { name: "Nebula Violet", hex: "#E056FD" },
];

// Ship variants pupils can pick.
export const SHIP_VARIANTS = [
  { id: "rocket", name: "Rocket" },
  { id: "shuttle", name: "Space Shuttle" },
  { id: "saucer", name: "Flying Saucer" },
  { id: "ufo", name: "UFO" },
  { id: "capsule", name: "Capsule" },
];

// Ships drawn nose-up (get rotated to face along the lane). Others hover flat.
export const VERTICAL_SHIPS = ["rocket", "shuttle", "capsule"];

export const STAGE_ICONS = ["🚀", "🌍", "🔴", "🪐", "🌙", "⭐", "☄️", "🛰️", "👾", "🌟", "🌌", "🏆"];

export const STAGE_PRESETS = {
  "Space Journey": [
    { name: "Launch Pad", color: "#22D3EE", icon: "🚀" },
    { name: "Blue Planet", color: "#3B82F6", icon: "🌍" },
    { name: "Red Planet", color: "#EF4444", icon: "🔴" },
    { name: "Ringed Giant", color: "#F59E0B", icon: "🪐" },
    { name: "New Galaxy", color: "#E056FD", icon: "🌌" },
  ],
  "Reading Marathon": [
    { name: "Launch Pad", color: "#22D3EE", icon: "📖" },
    { name: "Chapter Planet", color: "#A855F7", icon: "📗" },
    { name: "Halfway Moon", color: "#FFD166", icon: "📙" },
    { name: "Almost There", color: "#FF6B35", icon: "📕" },
    { name: "Reader Galaxy", color: "#EC4899", icon: "🌌" },
  ],
  "Science Project": [
    { name: "Launch Pad", color: "#22D3EE", icon: "🔬" },
    { name: "Experiment Planet", color: "#06D6A0", icon: "🧪" },
    { name: "Results Ringworld", color: "#F59E0B", icon: "📊" },
    { name: "Discovery Galaxy", color: "#E056FD", icon: "🌌" },
  ],
};

export const DEFAULT_STAGES = STAGE_PRESETS["Space Journey"];

// Branded hosts. Map these via custom domain at deploy time.
export const BRAND_HOST = "stellarsteps.online";
export const JOIN_HOST = "join.stellarsteps.online";

// True when the app is being served from the pupil join subdomain (join.*).
export function isJoinHost() {
  return typeof window !== "undefined" && window.location.hostname.startsWith("join.");
}

// The URL pupils should visit to join. On the real domain we point them at the
// join subdomain root; elsewhere (preview/local) we fall back to the /join path.
export function joinUrl() {
  if (typeof window !== "undefined" && window.location.hostname.endsWith("stellarsteps.online")) {
    return `https://${JOIN_HOST}`;
  }
  if (typeof window !== "undefined") return `${window.location.origin}/join`;
  return `https://${JOIN_HOST}`;
}
